import { closeDrawer } from '../../drawer';

export const initBackButtons = () => {
  const backButtons = document.querySelectorAll('[data-drawer-selector="drawer-close"]')
  backButtons.forEach(button => {
    button.addEventListener('click', e => {
      const drawerElement = button.closest('[data-drawer-selector="drawer"]')
      closeDrawer(drawerElement)
    })
  })
}